const reformatType = (type: string): string => type.split('_').reverse().map((word: string) => word.charAt(0).toUpperCase()
  + word.slice(1)).join(' ')

export default reformatType
